import * as Highcharts from 'highcharts';
import * as _ from 'underscore';

import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DatatableV4Component } from '../datatable-v4/datatable-v4.component';

@Component({
	selector: 'app-ctv-performance-detail-v4',
	styleUrls: ['./ctv-performance-detail-v4.component.css'],
	templateUrl: './ctv-performance-detail-v4.component.html'
})
export class CtvPerformanceDetailV4Component extends DatatableV4Component implements OnInit {
	@Input() tertiarykey;
	@Input() colorsconfig: any;
	@Input() key: string;
	@Input() chartconfiguration: any;
	@Input() sectiontitle: string;
	@Input() datatableconfig;
	@Input() iscustomendpoint: any;

	public colorPalette: ColorPalette;
	public reloadSubscription: any;
	public widgetDataSubscription: any;
	public chartConfig: any;
	public chartObj: any;
	public hasDaypartData = false;
	public featureLoad: boolean;
	public featuredNetworks: any[];
	public showLoadForDayPart: boolean;
	public daypartChartObjArray: any[] = [];
	public timezone: string = '';

	@ViewChild('chartElementId', { static: true }) chartElement: ElementRef;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected colorUtilityService: ColorUtilityService
	) {
		super(analyticsService, analyticsDataModel);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.hasData = false;
			this.showLoad = true;
			this.showLoadForDayPart = true;
			this.featureLoad = true;
			this.hasDaypartData = false;
			this.requestDaypartData();
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.requestDaypartData();
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}

	processDaypartResponseData(data: any): void {
		this.daypartChartObjArray = this.buildDayPartChartCollatorByFields(data);
		this.daypartChartObjArray[0].chartObj.map((chartData, index) => {
			if (chartData.dayparttime) {
				chartData.color = this.getColorFromColorConfig(index, 1);
			}
		});
		this.drawDonutChart();
	}

	buildDayPartChartCollatorByFields(daypartResponseData: any): any[] {
		const fieldChartArray: any[] = [];
		const chartObjArray: any[] = [];
		const daypartData: any = {};
		for (let index = 0; index < daypartResponseData.length; index++) {
			const chartObj: any = {};
			chartObj.name = daypartResponseData[index].daypart;
			chartObj.dayparttime = daypartResponseData[index].friendly_name;
			chartObj.y = Number(daypartResponseData[index].impressions);
			chartObj.displayOrder = daypartResponseData[index].display_order || index;
			chartObjArray.push(chartObj);
		}
		daypartData.chartObj = _.sortBy(chartObjArray, 'displayOrder');
		fieldChartArray.push(daypartData);
		return fieldChartArray;
	}

	requestDaypartData(): void {
		this.showLoadForDayPart = true;
		this.analyticsService.processCustomServiceRequest(this.tertiarykey).subscribe((response: any) => {
			this.featureLoad = false;
			this.showLoadForDayPart = false;
			this.timezone = response && response.timezone ? `(${response.timezone})` : '';
			if (response.success && response.data.length > 0) {
				this.hasDaypartData = true;
				this.processDaypartResponseData(response.data);
			} else {
				this.hasDaypartData = false;
			}
		});
	}

	drawDonutChart(): void {
		this.chartObj = Highcharts.chart({
			chart: {
				margin: this.chartConfig.graphConfig.margin,
				renderTo: this.chartElement.nativeElement
			},
			credits: {
				enabled: false
			},
			legend: {
				align: this.chartConfig.graphConfig.legendConfig.align,
				itemDistance: this.chartConfig.graphConfig.legendConfig.itemDistance,
				itemHoverStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.color,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemHoverStyle.fontWeight
				},
				itemMarginBottom: this.chartConfig.graphConfig.legendConfig.itemMarginBottom,
				itemStyle: {
					color: this.chartConfig.graphConfig.legendConfig.itemStyle.color,
					fontWeight: this.chartConfig.graphConfig.legendConfig.itemStyle.fontWeight
				},
				itemWidth: this.chartConfig.graphConfig.legendConfig.itemWidth,
				labelFormatter(): string {
					return this.name;
				},
				verticalAlign: this.chartConfig.graphConfig.legendConfig.verticalAlign,
				x: this.chartConfig.graphConfig.legendConfig.x,
				y: this.chartConfig.graphConfig.legendConfig.y
			},
			plotOptions: {
				pie: {
					borderWidth: 0,
					states: {
						inactive: {
							opacity: 1
						}
					}
				}
			},
			series: [
				{
					data: this.daypartChartObjArray[0].chartObj,
					dataLabels: {
						enabled: false
					},
					innerSize: this.chartConfig.seriesConfig[0].innerSize,
					showInLegend: true,
					size: this.chartConfig.seriesConfig[0].size,
					states: {
						hover: {
							enabled: false
						}
					},
					type: this.chartConfig.seriesConfig[0].type
				}
			],
			title: {
				text: null
			},
			tooltip: {
				backgroundColor: this.chartConfig.seriesConfig[0].tooltipInfo[0].backgroundColor,
				borderWidth: this.chartConfig.seriesConfig[0].tooltipInfo[0].borderWidth,
				padding: this.chartConfig.seriesConfig[0].tooltipInfo[0].padding,
				shadow: this.chartConfig.seriesConfig[0].tooltipInfo[0].shadow,
				style: {
					color: this.chartConfig.seriesConfig[0].tooltipInfo[0].style.color
				},
				useHTML: true,
				formatter(): string {
					return `<div style="text-align: center; font-size: 14px">
					<div style="padding-bottom: 5px;">${this.point['dayparttime']}</div>
					<div>${this.y} impressions</div>
					</div>
					`;
				}
			}
		});
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];

		const fillOpacity = colorConfig ? colorConfig.opacity : opacity;
		let rgb = '';
		if (colorConfig && colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else if (colorConfig && colorConfig.color) {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
}
